module.exports = __webpack_public_path__ + "img/magento_2.6d6a603c.png";